module.exports = __webpack_public_path__ + "static/media/threema.5e272e3a.svg";